import { enableProdMode } from '@angular/core';
import { registerLicense } from '@syncfusion/ej2-base';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { ThemeService } from './app/base/services/theme.service';
import { appConfig } from './app/app.config';

export function themeConfigFactory(themeService: ThemeService) {
  return () => themeService.initTheme()
}

// Registering Syncfusion license key
registerLicense(environment.syncfusionKey);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
